export type ObserverHandler = (_subject: object, ..._args: unknown[]) => void;
export type Observer = object;

export class Subject {
  observers: Set<Observer>;

  constructor() {
    this.observers = new Set();
  }

  subscribe(observer: Observer) {
    if (!(observer instanceof Object)) {
      throw new Error('Invalid observer');
    }
    this.observers.add(observer);
  }

  unsubscribe(observer: Observer) {
    this.observers.delete(observer);
  }

  notify(action: string, ...args: unknown[]) {
    this.observers.forEach(observer => {
      const handler = (observer as Record<string, unknown>)[action];
      if (typeof handler === 'function') {
        handler(this, ...args);
      }
    });
  }
}
